export const DEFAULT_DASHBOARD_APP_ICON = 'layout-grid-line';
export const DEFAULT_DASHBOARD_APP_POSITION = 'contacts';

export const DASHBOARD_APP_POSITION_ANCHORS = [
  {
    value: 'contacts',
    menuName: 'Contacts',
    routeName: 'contacts_dashboard_index',
  },
  {
    value: 'companies',
    menuName: 'Companies',
    routeName: 'companies_dashboard_index',
  },
  {
    value: 'crm',
    menuName: 'CRM',
    routeName: 'kanban_pipeline',
    featureFlag: 'kanban',
  },
  {
    value: 'reports',
    menuName: 'Reports',
    routeName: 'account_overview_reports',
    featureFlag: 'reports',
  },
  {
    value: 'campaigns',
    menuName: 'Campaigns',
    routeName: 'campaigns_livechat_index',
    featureFlag: 'campaigns',
  },
  {
    value: 'help_center',
    menuName: 'Portals',
    routeName: 'portals_index',
    featureFlag: 'help_center',
  },
  {
    value: 'cortex',
    menuName: 'Cortex',
    routeName: 'cortex_index',
    featureFlag: 'cortex_integration',
  },
  {
    value: 'flowbuilder',
    menuName: 'FlowBuilder',
    routeName: 'flowbuilder_index',
    featureFlag: 'flowbuilder',
  },
];

const anchorIndex = new Map(
  DASHBOARD_APP_POSITION_ANCHORS.map((anchor, index) => [anchor.value, index])
);
const menuPosition = new Map(
  DASHBOARD_APP_POSITION_ANCHORS.map((anchor, index) => [
    anchor.menuName,
    index * 2,
  ])
);
const fallbackPosition = DASHBOARD_APP_POSITION_ANCHORS.length * 2;

export const normalizeDashboardAppPosition = position =>
  anchorIndex.has(position) ? position : DEFAULT_DASHBOARD_APP_POSITION;

export const availableDashboardAppPositionAnchors = ({
  routes,
  shouldShow,
  isFeatureEnabled,
}) => {
  const routesByName = new Map(routes.map(route => [route.name, route]));

  return DASHBOARD_APP_POSITION_ANCHORS.filter(anchor => {
    const route = routesByName.get(anchor.routeName);
    if (!route) return false;

    const { featureFlag, permissions, installationTypes } = route.meta || {};
    if (anchor.featureFlag && !isFeatureEnabled(anchor.featureFlag)) {
      return false;
    }

    return shouldShow(featureFlag, permissions, installationTypes);
  });
};

const itemPosition = item => {
  if (item.dashboardAppPosition) {
    return (
      anchorIndex.get(
        normalizeDashboardAppPosition(item.dashboardAppPosition)
      ) *
        2 +
      1
    );
  }

  return menuPosition.get(item.name) ?? fallbackPosition;
};

export const dashboardAppIconClass = icon =>
  icon ? `i-ri-${icon}` : 'i-lucide-panels-top-left';

export const sortPostContactMenuItems = items =>
  [...items].sort((left, right) => {
    const leftPosition = itemPosition(left);
    const rightPosition = itemPosition(right);

    if (leftPosition !== rightPosition) return leftPosition - rightPosition;
    return (left.dashboardAppId || 0) - (right.dashboardAppId || 0);
  });
